import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from '../../../services/alerts.service';
import { UserService } from '../../../services/user.service';
import { TaskService } from '../../services/task.service';

/**
 * Component for managing unsaved task annotations.
 */
@Component({
	selector: 'workflow-task-dirty-management',
	templateUrl: './task-dirty-management.component.html',
	styleUrl: './task-dirty-management.component.css'
})
export class TaskDirtyManagementComponent implements OnInit {
	@Input() task: any;

	LOCALIZATION: any;

	inprogress: boolean = false;

	constructor(
		private modalService: NgbActiveModal,
		private alertsService: AlertsService,
		private taskService: TaskService,
		private userService: UserService
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
	}

	clearDirtyFlag(): void {
		this.taskService.resetDirtyEditFlag();
		this.close();
	}

	/**
	 * Saves the task annotation session.
	 */
	saveAnnotationSession(): void {
		this.inprogress = true;

		this.taskService.saveTaskAnnotationSession(this.task.uuid, this.task.taskid, this.task.annotations).then(
			(response: any) => {
				this.alertsService.success({
					message: "Annotation session saved."
				});
				this.proceed();
			},
			(err: any) => {
				console.error("Failed to save the task annotation session", err);
				this.alertsService.error({
					message: "Failed to save the annotation session."
				});
				this.inprogress = false;
			}
		);
	}

	/**
	 * Closes the modal, returning a result of ok and payload.
	 */
	proceed(): void {
		let caller = {
			callerName: 'workflowTaskDirtyManagement'
		};

		this.modalService.close({
			result: { answer: 'ok', caller: caller },
			timestamp: new Date(),
		});
	}

	/**
	 * Closes the modal.
	 */
	close(): void {
		this.modalService.dismiss();
	}
}
